import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Hub from 'base/hub'
import Event from 'base/event'

import NewUserModal from 'desktop/components/modals/new_user_modal'

class SneakPeekLoginModal extends Component {
  static propTypes = {
    siteLocation: PropTypes.string,
    onSignInSuccess: PropTypes.func,
    onSignUpSuccess: PropTypes.func,
    onRequestClose: PropTypes.func.isRequired,
    isNewUser: PropTypes.bool,
    skipEmailEntry: PropTypes.bool,
    className: PropTypes.string,
    isSigningIn: PropTypes.bool,
  }

  state = {
    isNewUser: this.props.isNewUser,
    isPasswordlessUser: false,
  }

  constructor(props) {
    super(props)

    this.handleEmailChecked = this.handleEmailChecked.bind(this)
    this.handleSignInSuccess = this.handleSignInSuccess.bind(this)
    this.handleSignUpSuccess = this.handleSignUpSuccess.bind(this)
    this.handleRequestClose = this.handleRequestClose.bind(this)
  }

  componentDidMount() {
    Hub.pub(Event.Login.MODAL_VIEW, { site_location: this.props.siteLocation })
  }

  handleRequestClose() {
    Hub.pub(Event.Login.MODAL_CLOSED, {
      site_location: this.props.siteLocation,
    })
    this.props.onRequestClose()
  }

  handleEmailChecked({ isNewUser, isPasswordlessUser }) {
    this.setState({ isNewUser, isPasswordlessUser })
  }

  handleSignInSuccess() {
    if (this.props.onSignInSuccess) {
      this.props.onSignInSuccess()
    }

    this.props.onRequestClose()
  }

  handleSignUpSuccess() {
    if (this.props.onSignUpSuccess) {
      this.props.onSignUpSuccess()
    }

    this.props.onRequestClose()
  }

  render() {
    return (
      <NewUserModal
        isSigningIn={this.props.isSigningIn}
        siteLocation={this.props.siteLocation}
        onSignInSuccess={this.handleSignInSuccess}
        onSignUpSuccess={this.handleSignUpSuccess}
        onRequestClose={this.handleRequestClose}
        isNewUser={this.state.isNewUser}
        skipEmailEntry={this.props.skipEmailEntry}
      />
    )
  }
}

export default SneakPeekLoginModal
